import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Fade from '../../components/Fade';

const ScreenBackground = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${(props) => props.backgroundImage});
  background-size: 100%;
`;

const fadeStyle = {
  width: '100%',
  height: '100%',
  position: 'relative',
};

const CardReaderScreen = ({ backgroundImage, fadeDuration, children }) => (
  <Fade duration={fadeDuration} style={fadeStyle}>
    <ScreenBackground backgroundImage={backgroundImage}>
      {children}
    </ScreenBackground>
  </Fade>
);

CardReaderScreen.propTypes = {
  backgroundImage: PropTypes.string.isRequired,
  fadeDuration: PropTypes.string,
  children: PropTypes.node,
};

CardReaderScreen.defaultProps = {
  fadeDuration: '500ms',
  children: null,
};

export default CardReaderScreen;
